(() => {
  if (window.nordesticPrestigeBridge) return;
  window.nordesticPrestigeBridge = true;

  // Order of preference after "In den Warenkorb":
  // 1. Slide Cart by AMP (app embed)  2. Prestige cart drawer  3. cart page.
  const slideCartReady = () => typeof window.SLIDECART_OPEN === 'function';

  // The Slide Cart script loads asynchronously; give it a short moment if it is not there yet.
  const waitForSlideCart = (ms = 2500) => new Promise(resolve => {
    if (slideCartReady()) return resolve(true);
    // Ohne die App (kein Slide-Cart-Skript auf der Seite) nicht warten: gleich die eigene Schublade nehmen.
    if (!document.querySelector('script[src*="slidecart"],#slidecarthq')) return resolve(false);
    const started = Date.now();
    const poll = setInterval(() => {
      if (slideCartReady()) { clearInterval(poll); resolve(true); }
      else if (Date.now() - started > ms) { clearInterval(poll); resolve(false); }
    }, 100);
  });

  // Refetch the cart (so the new item is shown), then open the Slide Cart.
  const openSlideCart = () => new Promise(resolve => {
    let opened = false;
    const open = () => {
      if (opened) return;
      opened = true;
      try { window.SLIDECART_OPEN(); } catch {}
      resolve();
    };
    const safety = setTimeout(open, 2500);
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        window.SLIDECART_UPDATE(() => { clearTimeout(safety); open(); });
      } else { clearTimeout(safety); open(); }
    } catch { clearTimeout(safety); open(); }
  });

  const prestigeDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.show === 'function' && window.themeVariables?.settings?.cartType === 'drawer' ? drawer : null;
  };

  const openPrestigeDrawer = (drawer, cartUrl) => {
    let finished = false, early = false;
    const complete = () => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      drawer.removeEventListener('cart-drawer:refreshed', complete);
      drawer.classList.remove('is-refreshing');
      if (!early) drawer.show();
    };
    const timeout = setTimeout(() => {
      if (finished) return;
      finished = true;
      drawer.removeEventListener('cart-drawer:refreshed', complete);
      location.assign(cartUrl);
    }, 8000);
    if (drawer.classList.contains('n-cd')) { try { drawer.classList.add('is-refreshing'); drawer.show(); early = true; } catch {} }
    drawer.addEventListener('cart-drawer:refreshed', complete, {once:true});
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const showCart = async cartUrl => {
    const own = prestigeDrawer();
    if (own && own.classList.contains('n-cd')) return openPrestigeDrawer(own, cartUrl);
    if (await waitForSlideCart()) return openSlideCart();
    const drawer = prestigeDrawer();
    if (drawer) return openPrestigeDrawer(drawer, cartUrl);
    location.assign(cartUrl);
  };

  // Product page app: item was added via /cart/add.js.
  document.addEventListener('nordestic:cart-added', event => {
    event.preventDefault();
    showCart(event.detail.cartUrl);
  });

  // Plain fallback form (only visible if the product app could not load).
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-nordestic-fallback-form]')) return;
    if (!slideCartReady() && !prestigeDrawer()) return; // normal submit -> cart page
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {Accept: 'application/json'},
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('add failed');
      await showCart(root + 'cart');
    } catch {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  }, true);
})();
